module.exports = __webpack_public_path__ + "img/enemy_123_003.e94ce4e1.png";